import { Link, TableColumn } from '@backstage/core-components';
import { CatalogTableRow } from '@backstage/plugin-catalog';
import { Entity, stringifyEntityRef } from '@backstage/catalog-model';
import { Typography } from '@material-ui/core';
import { relativeTime } from './relativeTime';
import { useLatestReleases } from './useLatestReleases';

const LatestReleaseCell = ({ entity }: { entity: Entity }) => {
  const latest = useLatestReleases();
  const release = latest?.[stringifyEntityRef(entity)];
  if (!release) {
    return <Typography variant="body2">—</Typography>;
  }
  return (
    <>
      <Typography variant="body2">
        {release.webUrl ? (
          <Link to={release.webUrl}>{release.tagName}</Link>
        ) : (
          release.tagName
        )}
      </Typography>
      <Typography
        variant="caption"
        component="div"
        color="textSecondary"
        title={new Date(release.releasedAt).toLocaleString()}
      >
        {relativeTime(release.releasedAt)}
      </Typography>
    </>
  );
};

/**
 * Latest-release column for the catalog index. All cells read from one
 * batched request (see useLatestReleases), not one request per row.
 */
export function createLatestReleaseColumn(): TableColumn<CatalogTableRow> {
  return {
    title: 'Latest release',
    render: row => <LatestReleaseCell entity={row.entity} />,
  };
}
